import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const InviteeOrientationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"InviteeOrientation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"oneTimeMessagesDismissed"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"InviteeOrientation","document":InviteeOrientationDocument}} as const;
export type InviteeOrientationQueryVariables = Types.Exact<{
  memberId: Types.Scalars['ID'];
}>;


export type InviteeOrientationQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'oneTimeMessagesDismissed'>
  )> }
);

/**
 * __useInviteeOrientationQuery__
 *
 * To run a query within a React component, call `useInviteeOrientationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInviteeOrientationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInviteeOrientationQuery({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useInviteeOrientationQuery(
  baseOptions: TrelloQueryHookOptions<
    InviteeOrientationQuery,
    InviteeOrientationQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: InviteeOrientationDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    InviteeOrientationQuery,
    InviteeOrientationQueryVariables
  >(InviteeOrientationDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useInviteeOrientationLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    InviteeOrientationQuery,
    InviteeOrientationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    InviteeOrientationQuery,
    InviteeOrientationQueryVariables
  >(InviteeOrientationDocument, options);
}
export type InviteeOrientationQueryHookResult = ReturnType<
  typeof useInviteeOrientationQuery
>;
export type InviteeOrientationLazyQueryHookResult = ReturnType<
  typeof useInviteeOrientationLazyQuery
>;
export type InviteeOrientationQueryResult = Apollo.QueryResult<
  InviteeOrientationQuery,
  InviteeOrientationQueryVariables
>;
